export const ALL_BLOG_CATOGRIES = "ALL_BLOG_CATOGRIES";
export const SEL_BLOG_CATOGRIES = "SEL_BLOG_CATOGRIES";
// export const ALL_RECRUITING = "ALL_RECRUITING";
// export const RECRUITING_COUNT = "RECRUITING_COUNT";
